import create from "zustand";

const useStatusStore = create((set: any) => ({
    status: "",
    setStatus: (data: string) => set(() => ({ status: data })),
}));

export { useStatusStore };
